const currencies = {
  'jp': {
    'symbol': '¥',
    'code': 'JPY',
    'css_class': 'icon-yen',
    'exponent': 0
  },
  'us': {
    'symbol': '$',
    'code': 'USD',
    'css_class': 'icon-dollar',
    'exponent': 2
  },
  'gu': {
    'symbol': '$',
    'code': 'USD',
    'css_class': 'icon-dollar',
    'exponent': 2
  },
  'au': {
    'symbol': '$',
    'code': 'AUD',
    'css_class': 'icon-dollar',
    'exponent': 2
  },
  'vn': {
    'symbol': '₫',
    'code': 'VND',
    'css_class': 'icon-dong',
    'exponent': 0
  },
  'sg': {
    'symbol': '$',
    'code': 'SGD',
    'css_class': 'icon-dollar',
    'exponent': 2
  },
  'id': {
    'symbol': 'Rp',
    'code': 'IDR',
    'css_class': 'icon-rupiah',
    'exponent': 2
  },
  'th': {
    'symbol': '฿',
    'code': 'THB',
    'css_class': 'icon-baht',
    'exponent': 2
  },
  'cn': {
    'symbol': '¥',
    'code': 'CNY',
    'css_class': 'icon-yen',
    'exponent': 2
  },
  'kr': {
    'symbol': '₩',
    'code': 'KRW',
    'css_class': 'icon-won',
    'exponent': 0
  },
  'nz': {
    'symbol': '$',
    'code': 'NZD',
    'css_class': 'icon-dollar',
    'exponent': 2
  },
  'ph': {
    'symbol': '₱',
    'code': 'PHP',
    'css_class': 'icon-peso',
    'exponent': 2
  },
  'my': {
    'symbol': 'RM',
    'code': 'MYR',
    'css_class': 'icon-rm',
    'exponent': 2
  },
  'tw': {
    'symbol': '$',
    'code': 'TWD',
    'css_class': 'icon-dollar',
    'exponent': 2
  }
}

export default currencies
